import { Module, VuexModule } from "vuex-module-decorators";

import ChallengeStore from "@/store/modules/challenges";
import SubmissionStore from "@/store/modules/submissions";

import { ChallengeResult } from "@/models/definitions";

@Module
export default class ChallengeResults extends VuexModule {
  get allChallengeResults(): ChallengeResult[] {
    const challengesStore = this.context.rootGetters as ChallengeStore;
    const submissionsStore = this.context.rootGetters as SubmissionStore;

    const challengeResults = [];

    const submissions = submissionsStore.allSubmissions;
    const challenges = challengesStore.allChallenges;
    for (const challenge of challenges) {
      challengeResults.push({
        challenge: challenge,
        submission: submissions ? submissions[challenge.id] : null,
      });
    }
    return challengeResults;
  }

  get allChallengeResultsForCampaign(): (id: number) => ChallengeResult[] {
    return (id: number) =>
      this.allChallengeResults.filter(
        (challengeResult) => challengeResult.challenge.campaign_id == id
      );
  }

  get oneChallengeResult() {
    return (id: number) =>
      this.allChallengeResults.find(
        (challengeResult) => challengeResult.challenge.id == id
      );
  }

  get numCompletedChallengeResultsForCampaign() {
    return (id: number) =>
      this.allChallengeResults.filter(
        (challengeResult) =>
          challengeResult.challenge.campaign_id == id &&
          challengeResult.submission
      ).length;
  }
}
